<p style="font-size: 12px; font-style: italic; color: var(--red-inforius)">
  <i class="bi bi-exclamation-triangle-fill"></i>
  {{ errorMessage() ?? ('error.global.required_field' | translate) }}
</p>
